import { SpoDocument } from 'api/types/entity/spoDocument';

import { GET_STUDENT_SPO_DOCUMENTS } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponse } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type StudentSpoDocumentsState = ICommonResponse<SpoDocument>;

const initialState: StudentSpoDocumentsState = {
  content: [],
  loading: false,
};
const generic = genericReducers<StudentSpoDocumentsState>();
const studentSpoDocuments: IReducers<StudentSpoDocumentsState> = {
  [GET_STUDENT_SPO_DOCUMENTS[REQUEST]]: generic.get.request,
  [GET_STUDENT_SPO_DOCUMENTS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_SPO_DOCUMENTS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_SPO_DOCUMENTS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentSpoDocuments);
